/* eslint-disable react/prop-types */
import React from "react";
import classNames from "classnames";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Hidden from "@material-ui/core/Hidden";

// @material-ui/icons
import PersonOutlineOutlinedIcon from "@material-ui/icons/PersonOutlineOutlined";

// core components
import Button from "components/CustomButtons/Button.js";

import styles from "assets/jss/material-dashboard-pro-react/components/topNavbarLinksStyle.js";

import ProfileMenu from "components/DropdownMenus/ProfileMenu";
import { getLoggedInName, handleClickProfile } from "helpers/authHelpers";
import { authStore } from "store";

const useStyles = makeStyles(styles);

export default function HeaderLinks() {
  const loggedInName = authStore((state) => state.loggedInName);
  const [isInFullScreen, setIsInFullScreen] = React.useState(false);

  const [openProfile, setOpenProfile] = React.useState(null);

  const [openNotifications, setOpenNotifications] = React.useState(null);

  const classes = useStyles();

  const wrapper = classNames({});
  const managerClasses = classNames({
    [classes.managerClasses]: true,
  });
  return (
    <div className={wrapper}>
      <div className={classes.managerClasses}>
        <div className={classes.loggedInUser}>
          <h5 className={classes.boldText}>{loggedInName}</h5>
        </div>
        <Hidden mdUp implementation="css">
          <span className={classes.linkText}>{"FullScreen"}</span>
        </Hidden>
      </div>

      <div className={managerClasses}>
        <Button
          color="primary"
          aria-label="Person"
          round
          size="lg"
          justIcon
          aria-owns={openProfile ? "profile-menu-list" : null}
          aria-haspopup="true"
          onClick={(event) =>
            handleClickProfile(event, openProfile, setOpenProfile)
          }
          muiClasses={{
            label: "",
          }}
        >
          <PersonOutlineOutlinedIcon className={classes.buttonLink} />
          <Hidden mdUp implementation="css">
            <span
              onClick={() =>
                handleClickProfile(event, openProfile, setOpenProfile)
              }
              className={classes.linkText}
            >
              {"Profile"}
            </span>
          </Hidden>
        </Button>
        <ProfileMenu
          openProfile={openProfile}
          setOpenProfile={setOpenProfile}
        />
      </div>
    </div>
  );
}
